import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';

export const ClientFactoringTag: React.FC = () => {
  const { t } = useTranslation('client');

  return <Tag color='purple'>{t('factoring')}</Tag>;
};
